import { useMutation, useQueryClient } from "react-query";

import { subscriptionItemsKey } from "../../queries";
import { updateSubscription } from "./updateSubscription.fetcher";

export function useUpdateSubscriptionMutation() {
  const queryClient = useQueryClient();

  return useMutation(updateSubscription, {
    onSettled: () => {
      queryClient.invalidateQueries(subscriptionItemsKey);
    },
  });
}
